export const LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL = {
  '1': 'Instant Delivery',
  '2': 'Standard Delivery',
  '-2': 'Self Pickup',
} as const;

export const INSTANT_DELIVERY_LABEL = LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL['1'];
export const STANDARD_DELIVERY_LABEL = LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL['2'];

export const CPT_SLAB_BADGE_ABBREVIATIONS = {
  INSTANT: 'ID',
  STANDARD: 'SD',
  SELF_PICKUP: 'SP',
} as const;

export function formatMinInstantDeliveryChargeMessage(
  minCharge: number,
  currency: '₹' | 'Rs.' = '₹',
): string {
  return `Delivery charge must be at least ${currency}${minCharge} for ${INSTANT_DELIVERY_LABEL}`;
}

export function formatMinInstantDeliveryCostMessage(
  minCost: number,
  currency: '₹' | 'Rs.' = 'Rs.',
): string {
  return `Delivery cost must be at least ${currency}${minCost} for ${INSTANT_DELIVERY_LABEL}`;
}
